module.exports = __webpack_public_path__ + "static/media/asist.carretera.6f526065.png";